import { Injectable } from '@angular/core';
import { driver } from "driver.js";

@Injectable({ providedIn: 'root' })
export class WalkthroughService {

  startTour() {

    // 👉 Open the dropdown first
    const dropdownButton = document.getElementById('dropdownMenuLink');
    if (dropdownButton) dropdownButton.click();

    setTimeout(() => {
      const driverObj = driver({
        animate: true,
        allowClose: true,
        overlayOpacity: 0.6,
        stagePadding: 8,
        popoverClass: 'driverjs-theme',
        showProgress: true,

        steps: [
          {
            element: '#dropdownMenuLink',
            popover: {
              title: 'Resources Menu',
              description: 'Click here to open Docs and Video Guides.',
              side: 'bottom',
              align: 'start'
            }
          },
          {
            element: '.resources-item:nth-child(1)',
            popover: {
              title: 'Docs',
              description: 'View detailed product documentation.',
              side: 'left',
              align: 'center'
            }
          },
          {
            element: '.resources-item:nth-child(2)',
            popover: {
              title: 'Video Guides',
              description: 'Watch step-by-step video tutorials.',
              side: 'left',
              align: 'center'
            }
          }
        ]
      });

      driverObj.drive();
    }, 300); // small delay so dropdown animates open
  }
}
